import { Form, Title } from 'ui';
import type { ActivityOption, TaskKindOption } from '../activity-types';
import { Task } from './task';

type P = {
  disabledEdit: boolean;
  disabledEditWithings: boolean;
  onSelectTaskKind: (kind: TaskKindOption) => void;
  type: ActivityOption;
};

const ActivityFormStep3 = ({ disabledEdit, disabledEditWithings, onSelectTaskKind, type }: P) => (
  <div className="activity-form-step-3">
    <Title level={3} marginBottom>
      Describe the question or response.
    </Title>
    <Form.List name="tasks">
      {(fields) =>
        fields.map((field) => (
          <Task
            disabledEdit={disabledEdit}
            disabledEditWithings={disabledEditWithings}
            field={field}
            key={field.key}
            onSelectTaskKind={onSelectTaskKind}
            type={type}
          />
        ))
      }
    </Form.List>
  </div>
);

export default ActivityFormStep3;
